<script setup>
import { computed, onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';
import { useAlert } from 'dashboard/composables';
import { useMapGetter, useStore } from 'dashboard/composables/store';
import PageLayout from 'dashboard/components-next/captain/PageLayout.vue';
import BotBehaviorTab from 'dashboard/routes/dashboard/settings/agentBots/components/BotBehaviorTab.vue';

// How the agent's bot engages - when it answers, how it splits and paces messages, its phases - is
// the bot's, shared with every other kind of bot. Here it is the same form, for this agent's bot.
const store = useStore();
const route = useRoute();
const { t } = useI18n();

const agentBots = useMapGetter('agentBots/getBots');
const uiFlags = useMapGetter('agentBots/getUIFlags');

const assistantId = computed(() => Number(route.params.assistantId));
const bot = computed(() =>
  agentBots.value.find(
    item =>
      item.bot_type === 'ai_agent' &&
      Number(item.bot_config?.assistant_id) === assistantId.value
  )
);

const updateBot = async data => {
  try {
    await store.dispatch('agentBots/update', { id: bot.value.id, data });
    useAlert(t('AGENT_BOTS.EDIT.API.SUCCESS_MESSAGE'));
  } catch (error) {
    useAlert(t('AGENT_BOTS.EDIT.API.ERROR_MESSAGE'));
  }
};

onMounted(() => {
  store.dispatch('agentBots/get');
});
</script>

<template>
  <PageLayout
    :show-pagination-footer="false"
    :show-know-more="false"
    :is-fetching="uiFlags.isFetching && !bot"
  >
    <template #body>
      <BotBehaviorTab
        v-if="bot"
        :bot="bot"
        :is-updating="uiFlags.isUpdating"
        @save="updateBot"
      />
    </template>
  </PageLayout>
</template>
